'use client'; 
import React from 'react';
import Link from '../components/SafeLink'; 

interface CardProps {
  label: string;
  text: string;
  bgClass: string;
  href: string;
}

const Card = ({ label, text, bgClass, href }: CardProps) => (
  <Link href={href} className="block w-full md:w-[400px]">
    <div className={`relative h-[450px] md:h-[550px] overflow-hidden flex flex-col justify-between transition duration-300 hover:shadow-2xl hover:brightness-75 cursor-pointer ${bgClass} rounded-none`}>
      <div className="absolute top-6 left-6 bg-white text-black text-base font-semibold px-4 py-2 shadow">
        {label}
      </div>
      <div className="px-8 pt-24">
        <p className="text-3xl font-bold leading-snug text-black">{text}</p>
      </div>
      <div className="absolute bottom-6 right-6 w-14 h-14 bg-blue-800 text-white flex items-center justify-center text-3xl transition rounded-full">
        <svg width="24" height="24" fill="white" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 6l6 6-6 6" stroke="white" strokeWidth="2" fill="none" />
        </svg>
      </div>
    </div>
  </Link>
);

export default function CardsSection() {
  return (
    <section id="our-directions" className="bg-blue-800 pt-16 pb-12 md:pt-60 md:pb-20">
      <h2 className="text-3xl md:text-5xl font-bold text-center text-white mb-12 md:mb-20">НАШИ НАПРАВЛЕНИЯ</h2>
      <div className="flex flex-col md:flex-row flex-wrap justify-center md:justify-between gap-8 md:gap-y-16 px-6 md:px-12 max-w-[1900px] mx-auto">
        <Card label="Надёжность" text="Надёжные кадровые решения" bgClass="card-reliability" href="/reliability" />
        <Card label="Эффективность" text="Оптимизация трудовых ресурсов" bgClass="card-efficiency" href="/efficiency" />
        <Card label="Безопасность" text="Соблюдение трудового законодательства" bgClass="card-safety" href="/safety" />
        <Card label="Поддержка" text="Помощь в управлении персоналом" bgClass="card-support" href="/support" />
      </div>
    </section>
  );
}